import React from "react";
import "./AboutMe.css";

export default function AboutMe() {
  return (
    <section className="about-me-container">
      <div aria-hidden className="about-me-gradient" />

      <header className="about-me-header">
        <h1>About Me</h1>
        <p>
          Hey, I'm Ram, the founder of AllergyPatrol. <br />
          Come join me on this journey of spreading allergy awareness.
        </p>
      </header>

      <div className="about-me-card about-me-card--single">
        <div className="about-me-info">
          <h2>Ram Sarma</h2>
          <h4>Founder &amp; Developer</h4>

          <p>
            I’m a passionate software engineer and advocate for food allergy awareness. This app
            combines technology and my personal mission to help those affected by food
            allergies.
          </p>
          <p>
            With the AllergyPatrol app, users can quickly find allergen friendly
            foods, recipes, and resources.
          </p>

          <div className="about-me-badges">
            <span className="chip">Allergy Awareness</span>
            <span className="chip">Safer Eating</span>
          </div>
        </div>
      </div>
    </section>
  );
}
